import type { IToC } from "~/models/IToC";
import { LexmeaApiClient } from "./apiClient";

export class TableOfContentsClient extends LexmeaApiClient {
  fetchTableOfContents = (legalTextSlug: string) => {
    return this.get<IToC[]>(`api/legalText/${legalTextSlug}/toc`);
  };
}
